import { render, staticRenderFns } from "./ViewDocsTemplate.vue?vue&type=template&id=429196e7&scoped=true"
import script from "./ViewDocsTemplate.vue?vue&type=script&lang=js"
export * from "./ViewDocsTemplate.vue?vue&type=script&lang=js"
import style0 from "./ViewDocsTemplate.vue?vue&type=style&index=0&id=429196e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429196e7",
  null
  
)

export default component.exports